import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  root: {
    padding: '12px 14px',
    borderBottom: `1px solid ${token.colorBorderSecondary}`,
    minHeight: 48
  },
  left: {
    minWidth: 0,
    flex: '1 1 320px'
  },
  right: {
    flex: '0 0 auto',
    justifyContent: 'flex-end'
  }
}))
